export default __webpack_public_path__ + "static/media/volleyball2.f9a8c928.jpg";